import React from "react";
import {
  MsalAuthenticationTemplate,
  useIsAuthenticated
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import auth from "helpers/auth";
import RequireAuthProps from "./RequireAuth.types";
import Error from "common/ui/Error";
import Loading from "common/ui/Loading";
import { useUser } from "services/users.service";
import { Navigate } from "react-router-dom";

const RequireAuth = (props: RequireAuthProps) => {
  const isAuthenticated = useIsAuthenticated();
  const user = useUser(isAuthenticated);

  if (isAuthenticated && user.isLoading) {
    return <Loading />;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={auth.loginRequest}
      errorComponent={Error}
      loadingComponent={Loading}
    >
      <React.Suspense fallback={<Loading />}>
        {user.data?.isActive ? props.component : <Navigate to="/no-access" />}
      </React.Suspense>
    </MsalAuthenticationTemplate>
  );
};

export default RequireAuth;
